import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";
import IconButtonWrapper from "metabase/components/IconButtonWrapper";

export const RemoveRowButton = styled(IconButtonWrapper)`
  color: ${color("text-light")};
`;
